import { FC, ReactNode } from "react"
import { cn } from "../../utils"

interface ConfigAdminPanelProps {
  className?: string
  children: ReactNode
}

export const ConfigAdminPanel: FC<ConfigAdminPanelProps> = ({
  className,
  children
}) => (
  <div
    className={cn(
      "overflow-hidden rounded-xl border border-gray-200",
      className
    )}
  >
    {children}
  </div>
)
